import "bootstrap";

// Initialize AOS Animations
AOS.init();

// Home Hero Carousel
const swiper = new Swiper(".hero--home .swiper", {
  // Optional parameters
  loop: true,
  slidesPerView: 1,
  effect: "fade",
  lazy: true,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },

  // If we need pagination
  pagination: {
    el: ".hero--home .swiper .swiper-pagination",
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: ".hero--home .swiper .swiper-button-next",
    prevEl: ".hero--home .swiper .swiper-button-prev",
  },

  on: {
    slideChangeTransitionStart: function () {
      jQuery(".hero--home .swiper .hero__title").hide(0);
      jQuery(".hero--home .swiper .hero__subtitle").hide(0);
      jQuery(".hero--home .swiper .hero__description").hide(0);

      jQuery(".hero--home .swiper .hero__title").removeClass("aos-init").removeClass("aos-animate");
      jQuery(".hero--home .swiper .hero__subtitle").removeClass("aos-init").removeClass("aos-animate");
      jQuery(".hero--home .swiper .hero__description").removeClass("aos-init").removeClass("aos-animate");
    },
    slideChangeTransitionEnd: function () {
      jQuery(".hero--home .swiper .hero__title").show(0);
      jQuery(".hero--home .swiper .hero__subtitle").show(0);
      jQuery(".hero--home .swiper .hero__description").show(0);
      AOS.init();
    },
  },
});

(function ($) {
  // On Dom Ready
  $(function () {
    // Toggle mobile menu
    $(".menu-open").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("is-active");
      $("body").toggleClass("no-scroll");
      $("body").toggleClass("menu-open");
      $(".mobile-menu-wrapper").fadeToggle();
    });

    // Show thankyou message after cf7 submit
    $(".wpcf7").on("wpcf7mailsent", function (event) {
      $(".contact-form-thank-you").fadeIn();
    });

    // Toggle footer menus on mobile
    $("footer .footer__title").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });

    /* $(window).scroll(function (e) {
      parallax();
    });

    function parallax() {
      var scrolled = $(window).scrollTop();
      $(".hero--home").css("top", -(scrolled * 0.0315) + "rem");
      $(".hero--home .hero__title").css("top", -(scrolled * -0.005) + "rem");
      $(".hero--home .hero__title").css("opacity", 1 - scrolled * 0.00175);
      $(".hero--home .hero__subtitle").css("top", -(scrolled * -0.005) + "rem");
      $(".hero--home .hero__subtitle").css("opacity", 1 - scrolled * 0.00175);
      $(".hero--home .hero__description").css("top", -(scrolled * -0.005) + "rem");
      $(".hero--home .hero__description").css("opacity", 1 - scrolled * 0.00175);
    } */
  });
})(jQuery);
